// @ts-check
import React, { Component } from 'react';
import 'Styles/commonComponents.scss';
import { observer } from 'mobx-react';
import IconsContainer from 'Utils/IconsContainer';
import Helper from "Utils/Helper";

/**
 * @typedef {object} item
 * @property {any} key
 * @property {string} value
 * 
 * @typedef {object} state
 * @property {boolean} show
 * @property {item[] | null} values
 * 
 * @typedef {object} props
 * @property {string} [id]
 * @property {string} [className]
 * @property {import('react').CSSProperties} [style]
 * @property {item[]} values
 * @property {any} selectedItem
 * @property {(arg0: any) => void} onSelectedItemChanged
 * @property {string} [emptyPlaceholder]
 * @property {boolean} [withInput]
 * @property {boolean} [autoOpenOnListChange]
 * @property {any[]} [disabledValues]
 * @property {string} [inputPlaceholder]
 * @property {string} [inputValue]
 * @property {(arg0: string) => void} [inputChange]
 * @extends {Component<props, state>}
 */
class ListBox extends Component {
    /**
     * @param {props} props
     */
    constructor(props) {
        super(props);
        /** @type {state} */
        this.state = {
            show: false,
            values: null //это архив. Не мапить на него рендер!
        };
    }

    /**
     * @param {props} props
     * @param {state} state
     * @returns {Partial<state> | null}
     */
    static getDerivedStateFromProps(props, state) {
        if (state.values == null)
            state.values = props.values;
        else {
            let valuesEqual = Helper.ArrayCompare(state.values, props.values);

            if (valuesEqual == false && props.autoOpenOnListChange && state.show == false) {
                return { show: true, values: props.values }
            }
        }

        return null;
    }

    changeOpenState() {
        if (this.props.values.length === 0 && this.state.show == false)
            return;

        let newState = this.state.show == false;
        this.setState({ show: newState });

        if (newState) {
            document.addEventListener('mousedown', e => this.handleClickOutside(e));
        }
    }

    handleClickOutside(event) {
        if (this.htmlElement && !this.htmlElement.contains(event.target)) {
            this.setState({ show: false });

            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }

    /**
     * @param {{ key: any }} item
     */
    selectValue(item) {
        this.setState({ show: false });

        this.props.onSelectedItemChanged(item.key)
    }

    render() {
        let valuesElement = this.state.show == false ? '' : (
            <div className="values-holder overflowing-element" key="values-holder">
                {
                    this.props.values.map(item => {
                        let disabledClass = '';
                        if (this.props.disabledValues != null && this.props.disabledValues.indexOf(item.key) >= 0)
                            disabledClass = 'disabled'

                        return (
                            <div className={`listbox-item ${disabledClass}`}
                                onClick={_ => this.selectValue(item)}
                                key={item.key}
                                title={item.value}>
                                {item.value}
                            </div>
                        )
                    })
                }
            </div>
        );

        let openedClass = this.state.show ? ' opened' : '';

        let selectedValue = this.props.values?.find(it => it.key == this.props.selectedItem)?.value;
        let hasValue = selectedValue ? true : false;
        selectedValue ??= this.props.emptyPlaceholder;

        return (
            <div
                className={`listbox ${this.props.className ?? ''}` + ((this.props.withInput || !hasValue) ? ' without-hover' : '')}    
                style={this.props.style}
                id={this.props.id}
                ref={node => this.htmlElement = node}
            >
                <div className={"listbox-header" + openedClass}
                    onClick={_ => this.changeOpenState()}>
                    {
                        (this.props.withInput
                            ?
                            <input onChange={(e) => this.props.inputChange?.(e.target.value)}
                                placeholder={this.props.inputPlaceholder}
                                value={this.props.inputValue} />
                            :
                            <div title={selectedValue}>
                                <span>{selectedValue}</span>
                                {
                                    hasValue ?
                                        <div className="drop-down-button">
                                            {IconsContainer.Get('ci-arrow-down')}
                                        </div>
                                        : ''
                                }
                            </div>)
                    }
                </div>
                {valuesElement}
            </div>
        );
    }
}

// @ts-ignore
export default observer(ListBox);